import React, { useCallback } from 'react';
import { Grid } from '~/components/';
import { useForm } from '~/hooks';
import { FaPencilAlt, FaTrash} from 'react-icons/fa';
import BookRecord from './BookRecord';
import { MdAddCircle } from 'react-icons/md';
import { useDeleteSectionDetail, useSaveSectionDetail } from '../../hooks';
import sectionTypes from '../sectionTypes';

/**
 * @typedef RecordedInBookValues
 * @property {number}   sectionId
 * @property {string}   titleOpinionId 
 * @property {boolean}  addRecordedInBook
 * @property {[object]} sectionDetails
 * @property {boolean}  addRecordBookFlag
 * 
 * @typedef FormState
 * @property {RecordedInBookValues} values The current form values
 */

/** @type {RecordedInBookValues} */

const defaultState = {
    id: 0,
    sectionDetails: [{
        sectionDetailId: 0, type: 'recordedInBook', book: '', pageNo: ''
    }],    
    addRecordBookFlag: false,
    recordBookDetailData: {},
    editRecord: false,
    sectionType: sectionTypes.RECORDED_PLAT
};

const loadData = async (values) => {
    return {
        ...values,
    };
};

const RecordedInBook = (props) => {

    const onLoad = useCallback((values) => {
        return loadData(values);
    }, [props.sectionId]);

    const { state, fieldActions } = useForm({
        initialState: { 
            ...defaultState},
        onLoad,     
        props,       
        debug: true 

    }); 

    const ownerDetail =  props.sectionDetails ? props.sectionDetails.map((detail) => {        
        return {
            ...detail,
            id: detail.sectionDetailId,
            book: detail._data.book,
            pageNo: detail._data.pageNo            
        } ;
    }) : [];

    const { deleteSectionDetail } = useDeleteSectionDetail(state.values.data, state.values.sectionDetailId);

    const onEditClick = async (data) => {
        await fieldActions.onChange(data, 'recordBookDetailData');
        await fieldActions.onChange(true, 'editRecord');
        fieldActions.onChange(true, 'addRecordBookFlag');
    };

    const onDeleteClick = (id) => {
        deleteSectionDetail(id);
    };

    const addRecordBookModal = () => {
        fieldActions.onChange(false, 'editRecord');
        fieldActions.onChange(true, 'addRecordBookFlag');
    };

    const cancelAddBook = () => {
        fieldActions.onChange(false, 'addRecordBookFlag');
    }; 

    const { saveField } = useSaveSectionDetail(state.values.data, state.values.sectionType, props.initialDefaultData, props.titleOpinionId, state.values.sectionDetailId);
    
    const addBook = async (values) => { 
        const data = {
            sectionId: props.sectionId,
            type: 'recordedInBook',
            book: values.book,
            pageNo: values.pageNo         
        };
        await fieldActions.onChange(data, 'data');
        await saveField( state.values.data, state.values.sectionType, props.initialDefaultData, props.titleOpinionId, state.values.sectionDetailId);
        await fieldActions.onChange(false, 'addRecordBookFlag');
        
    };

    const saveBook = async (newData) => {
        const data = {
            sectionId: props.sectionId,
            sectionDetailId: newData.recordBookDetailData.sectionDetailId,
            type: 'recordedInBook',
            book: newData.book,
            pageNo: newData.pageNo              
        };
        
        await fieldActions.onChange(data, 'data');
        await saveField( state.values.data, state.values.sectionType, props.initialDefaultData, props.titleOpinionId, data.sectionDetailId);
        fieldActions.onChange(false, 'addRecordBookFlag');
    };

    const columns = [
        {
            title: 'Book*',
            field: 'book',
            width: 500,
        },
        {
            title: 'Page No.*',
            field: 'pageNo',
            width: 500,
            
        },
        {
            field: 'editDelete',
            width: 150,
            canSort: false,
            cell: ({ data }) => {
                return (
                    <>
                        {!props.editMode ? '' :
                            <span className="flex justify-end h-10">
                                <button className="btn btn-link mr-5" 
                                    onClick={() => onEditClick(data)}>
                                    <FaPencilAlt />
                                </button>
                                <button className="btn btn-link" 
                                    onClick={() => onDeleteClick(data.id)}>
                                    <FaTrash />
                                </button>
                            </span>
                        }
                        
                    </>
                    
                );
            }
        }
    ];

    return (
        <React.Fragment>
            <div className="col-span-12 mt-5">
                <Grid
                    className="grid-stretch"
                    columns={columns}
                    data={ownerDetail}
                />
                <BookRecord
                    isModalOpen={state.values.addRecordBookFlag}
                    recordBookDetailData={state.values.recordBookDetailData}
                    editRecord={state.values.editRecord}
                    onCancel={() => cancelAddBook()}
                    headerTxt={'Add Book'}
                    sectionId={props.sectionId}
                    addBook={(values) => addBook(values)}
                    saveBook={(b) => saveBook(b)}
                />                
            </div>

            {!props.editMode ? '' : 
                <div className='mt-auto col-span-12'>
                    <div className="flex justify-start items-center pt-2 mt-auto">
                        <button
                            className='py-1.5 px-2 rounded-full text-white flex items-center focus:outline-none bg-blue-60 disabled:opacity-50'
                            onClick={() => addRecordBookModal()}
                        >
                            <MdAddCircle className="mr-2" size="1.25rem" />
                            Add Book
                        </button>
                    </div>
                </div>
            }
            
            
        </React.Fragment>
    );
};

export default RecordedInBook;